import { authHeaders } from '@/services/authHeaders';
import { getApiBaseUrl } from '@/utils/apiConfig';
import { createSourceUploader, sourceApi, type JsonFetch } from '../../../../web-core/src/upload/index';
import type { FootageUploadClient } from './uploadClient';

const fetchJson: JsonFetch = async (path, init) =>
  fetch(`${getApiBaseUrl()}/${path}`, {
    method: init?.method ?? 'GET',
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
    ...(init?.body === undefined ? {} : { body: JSON.stringify(init.body) }),
  });

/** Uploads a file straight to storage as material for the video; the agent may turn a video into cuttable footage later. */
export const productionUploadClient: FootageUploadClient = {
  async uploadFile({ conversationId, file, onProgress, signal }) {
    const uploader = createSourceUploader(sourceApi(conversationId, fetchJson, { use: 'asset' }));
    const { sourceId } = await uploader.upload(file, {
      signal,
      onProgress: ({ phase, sentBytes, totalBytes }) => {
        if (phase !== 'compressing') onProgress({ phase, sentBytes, totalBytes });
      },
    });
    return { sourceId };
  },
};
